<template>
  <div class="list_progress_none" v-if="list.content.length == 0">
    <p>
      요청하신 견적이 없습니다!<br />
      HOME 화면에서 나에게 맞는 상품을 찾아보세요!
    </p>
    <button @click="goLink('InternetCommerce.Main')">
      HOME으로 가기
    </button>
  </div>
  <div class="list_progress" v-else>
    <div class="progress_tab">
      <ul>
        <li
          :class="{ on: index == listSelectIndex }"
          v-for="(item, index) in list.content"
          :key="index"
          @click="listSelect(index, item.id)"
        >
          <button v-if="isStatus == 'END'">
            {{ getCreateAt(item.createdAt) }}<span class="fini">모집마감</span>
          </button>
          <button v-else>
            {{ getCreateAt(item.createdAt)
            }}<span>{{ getCreateAtDay(item.createdAt) }} 후 마감</span>
          </button>
          <div class="bg_box"></div>
        </li>
      </ul>
    </div>
    <div
      class="progress_cont"
      :class="{ on: index == listSelectIndex }"
      v-for="(item, index) in list.content"
      :key="index"
      @click="goDetail(item.id)"
    >
      <ul class="inter_prod_list">
        <li class="full">
          <dl>
            <dt>상품 구성</dt>
            <dd>
              {{ item.promotionCode == 'KT2408' ? '' : item.speed }}
              {{ item.itemUse }}{{ getPhoneJoin(item.phoneJoin) }}
            </dd>
          </dl>
        </li>
        <li class="full" v-if="item.promotionCode == 'MY_INTERNET'">
          <dl>
            <dt>요금제</dt>
            <dd v-html="isItemCompose(item)"></dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>기존통신사</dt>
            <dd>{{ item.currentTelecom || '-' }}</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>희망통신사</dt>
            <dd>{{ item.telecom || '-' }}</dd>
          </dl>
        </li>
        <li class="full">
          <dl>
            <dt>가입 유형</dt>
            <dd>{{ item.joinType }}</dd>
          </dl>
        </li>
        <li class="full">
          <dl>
            <dt>설치 지역</dt>
            <dd>{{ item.areaFullName }}{{ getAreaType(item.areaType) }}</dd>
          </dl>
        </li>
      </ul>
      <div v-if="item.internetCommerceStores">
        <div
          class="arrival"
          v-if="item.internetCommerceStores.length > 0 && isType == 'list'"
        >
          <div class="prof_area">
            <ul>
              <li
                v-for="(s_item, s_index) in item.internetCommerceStores.slice(
                  0,
                  3,
                )"
                :key="s_index"
              >
                <div class="profile_image">
                  <div class="thumb_image">
                    <div class="thumb_image_inner" v-if="s_item.storeProfile">
                      <img :src="s_item.storeProfile" alt="" />
                    </div>
                    <div class="thumb_image_inner" v-else>
                      <img
                        :src="
                          setShopProfileImg(s_item.storeName, s_item.storeId)
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="profile_image">
                  <div class="thumb_image">
                    <div class="thumb_image_inner">
                      <img
                        :src="
                          require('@/assets/front/images/v2/profiles/img_prof_more.png')
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </li>
              <!--4개까지는 매장 프로필 사진, 5개부터는 네번째 이미지는 이걸로-->
            </ul>
          </div>
          <p>
            총 {{ item.internetCommerceStores.length }}개의 견적이 도착했어요!
          </p>
          <!--받은 견적 수-->
          <div class="num" v-if="item.unreadCnt > 0">{{ item.unreadCnt }}</div>
          <!--확인 안 한 새로 받은 견적 수-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    list: Object,
    isType: String,
    isStatus: String,
    isSelectIndex: Number,
  },
  components: {},
  data(props) {
    return {
      listSelectIndex: props.isSelectIndex || 0,
      areaTypes: [
        { label: '아파트', value: 'APT' },
        { label: '빌라, 주택 등', value: 'HOUSE' },
        { label: '사무실', value: 'OFFICE' },
        { label: '영업매장', value: 'SHOP' },
      ],
    };
  },
  async created() {},
  computed: {},
  methods: {
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yy.MM.dd');
    },
    getCreateAtDay(createAt) {
      const createdAt = new Date(createAt);

      console.log(createdAt);

      const endDay = format(
        new Date(createdAt.setDate(createdAt.getDate() + 7)),
        'yyyy-MM-dd HH:mm:ss',
      );

      console.log(endDay);

      const now = new Date();
      new Date(now.setDate(now.getDate()), 'yyyy-MM-dd HH:mm:ss');

      console.log(now);

      var resdays = this.getDateDiff(now, endDay);

      console.log('박수 : ' + resdays);
      return resdays;
    },
    goLink(link) {
      this.$router.push({ name: link });
    },
    getDateDiff(d1, d2) {
      const date1 = new Date(d1);
      const date2 = new Date(d2);

      const diffDate = date1.getTime() - date2.getTime();

      let mathVal = Math.abs(diffDate / (1000 * 60 * 60 * 24));

      // 시간으로 표시
      if (mathVal < 1) {
        return (
          Math.ceil(Math.abs(diffDate / (1000 * 60 * 60))).toString() + '시간'
        ); // 밀리세컨 * 초 * 분 * 시 = 일
      } else {
        return (
          Math.ceil(Math.abs(diffDate / (1000 * 60 * 60 * 24))).toString() +
          '일'
        ); // 밀리세컨 * 초 * 분 * 시 = 일
      }
    },
    isItemCompose(item) {
      let itemCompose = '';

      if (item.itemInternet) {
        itemCompose = '[인터넷] ';
        itemCompose += item.itemInternet;
      }

      if (item.itemTv) {
        itemCompose += '<br/>';
        itemCompose += '[TV] ';
        itemCompose += item.itemTv;
      }

      return itemCompose;
    },
    listSelect(index, id) {
      this.listSelectIndex = index;
      if (this.isType == 'detail') {
        this.$emit('selectId', id, index);
      }
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '25');

      return path;
    },
    goDetail(id) {
      if (this.isType == 'list') {
        this.$emit('goDetail', id, 'ING');
      }
    },
    getAreaType(area) {
      if (!area || area == null) {
        return '';
      }
      const foundInfo = this.areaTypes.filter(info => info.value === area);

      if (foundInfo[0].label) {
        return ' | ' + foundInfo[0].label;
      }
      return '';
    },
    getPhoneJoin(phoneJoin) {
      if (phoneJoin == 'PHONE') {
        return '+휴대폰';
      } else if (phoneJoin == 'USIM') {
        return '+USIM';
      } else {
        return '';
      }
    },
  },
};
</script>
